var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgSearchAcceptedSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00065 0.431396C3.31865 0.431396 0.333984 3.41606 0.333984 7.09806C0.333984 10.7801 3.31865 13.7647 7.00065 13.7647C10.6827 13.7647 13.6673 10.7801 13.6673 7.09806C13.6673 3.41606 10.6827 0.431396 7.00065 0.431396ZM10.8053 5.5694L6.13865 10.2361C6.00865 10.3661 5.83798 10.4314 5.66732 10.4314C5.49665 10.4314 5.32598 10.3661 5.19598 10.2361L3.19598 8.23606C2.93532 7.9754 2.93532 7.55406 3.19598 7.2934C3.45665 7.03273 3.87798 7.03273 4.13865 7.2934L5.66732 8.82206L9.86265 4.62673C10.1233 4.36606 10.5447 4.36606 10.8053 4.62673C11.066 4.8874 11.066 5.30873 10.8053 5.5694Z",
    fill: "#0BA169"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchAcceptedSm);
export default __webpack_public_path__ + "static/media/search_accepted_sm.3d918195bf4e911e93703db177e00024.svg";
export { ForwardRef as ReactComponent };